import { CHAT_TEXTS as TEXTS } from "../texts.ts";
import { Markdown } from "./Markdown.tsx";

/**
 * Un documento en markdown que el sistema guarda y enseña entero.
 *
 * Existe para la mecánica del mes: su documento ES la fuente de verdad, y
 * resumirlo en el mensaje del agente no basta -- quien lo aprueba tiene que
 * poder leerlo tal cual está guardado. Es lo contrario de un `key_values`: no
 * son campos, es un texto con su estructura.
 */
interface Props {
  props: {
    readonly title?: string;
    readonly markdown?: string;
    /** Pares sueltos que van encima, como el periodo o la versión. */
    readonly meta?: readonly { label: string; value: string }[];
  };
}

export function Document({ props }: Props) {
  const { title, markdown, meta } = props;

  if (markdown === undefined || markdown.trim() === "") {
    return (
      <p className="text-sm text-muted-foreground">{TEXTS.document.empty}</p>
    );
  }

  return (
    // Se mira como un documento y no como el resultado de una herramienta: es
    // lo que alguien tiene que leer entero antes de aprobarlo.
    <article className="rounded-lg border bg-secondary/40 px-5 py-4">
      {title !== undefined && (
        <h3 className="mb-1.5 text-base font-semibold">{title}</h3>
      )}

      {meta !== undefined && meta.length > 0 && (
        <p className="mb-3 flex flex-wrap gap-x-4 gap-y-1 border-b pb-2.5 text-xs text-muted-foreground">
          {meta.map((item) => (
            <span key={item.label}>
              <b className="font-semibold">{item.label}:</b> {item.value}
            </span>
          ))}
        </p>
      )}

      {/* El cuerpo puede ser largo: se le pone tope y scroll propio para que no
          empuje la conversación entera hacia abajo. */}
      <div className="scroll-quiet max-h-128 overflow-y-auto">
        <Markdown text={markdown} />
      </div>
    </article>
  );
}
